import { Line, Doughnut } from 'react-chartjs-2';

const incidentTrends = {
  labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
  datasets: [{
    label: 'Incidents',
    data: [5, 3, 4, 2, 3, 1],
    borderColor: 'rgb(79, 70, 229)',
    tension: 0.4,
  }],
};

const resolutionMetrics = {
  labels: ['< 4h', '4-8h', '8-24h', '> 24h'],
  datasets: [{
    data: [45, 30, 15, 10],
    backgroundColor: [
      'rgb(34, 197, 94)',
      'rgb(234, 179, 8)',
      'rgb(249, 115, 22)',
      'rgb(239, 68, 68)',
    ],
  }],
};

const recentIncidents = [
  {
    id: 1,
    type: 'Security Breach',
    severity: 'high',
    status: 'resolved',
    resolution: '3.5 hours',
    date: '2024-01-15',
  },
  {
    id: 2,
    type: 'DDoS Attack',
    severity: 'medium',
    status: 'resolved',
    resolution: '2 hours',
    date: '2024-01-10',
  },
  {
    id: 3,
    type: 'Phishing Campaign',
    severity: 'low',
    status: 'resolved',
    resolution: '1 hour',
    date: '2024-01-05',
  },
];

export default function IncidentHistory() {
  return (
    <div className="space-y-6 mt-6">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-medium mb-4">Incident Trends</h3>
          <div className="h-64">
            <Line data={incidentTrends} />
          </div>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-lg font-medium mb-4">Resolution Time Distribution</h3>
          <div className="h-64">
            <Doughnut data={resolutionMetrics} />
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-medium mb-4">Recent Incidents</h3>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead>
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Type
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Severity
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Resolution Time
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Date
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {recentIncidents.map((incident) => (
                <tr key={incident.id}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {incident.type}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span
                      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                        incident.severity === 'high'
                          ? 'bg-red-100 text-red-800'
                          : incident.severity === 'medium'
                          ? 'bg-yellow-100 text-yellow-800'
                          : 'bg-green-100 text-green-800'
                      }`}
                    >
                      {incident.severity}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                      {incident.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {incident.resolution}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {incident.date}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}